import { RouteType } from "../../../types/RouteType";
import { PdfEditorViewStore } from "./PdfEditorViewStore";

const PdfEditorRoute: RouteType = {
  name: "Pdf Editor",
  path: "/pdf/:documentId/:tab",
  defaultParams: { tab: "viewer" },
  defaultQueryParams: { pageNumber: "1" },
  layout: "/app",
  requiresAuth: true,
  hidden: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./components/PdfEditor.Header"),
      title: "PDF",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./components/PdfEditor.Body"),
      grayBackground: true,
    },
  },

  beforeEnter: async ({ rootStore }) => {
    // Create the view store if it doesn't exist
    if (!(rootStore as any).pdfEditorViewStore) {
      (rootStore as any).pdfEditorViewStore = new PdfEditorViewStore(rootStore);
    }

    // The reaction in the view store will automatically load the document
    // when it detects the documentId from the route params
    return true;
  },

  onExit: ({ rootStore }) => {
    // Clean up the view store when leaving the route
    const pdfEditorViewStore = (rootStore as any).pdfEditorViewStore;
    if (pdfEditorViewStore) {
      pdfEditorViewStore.cleanup();
    }
  },

  dialogs: [
    {
      name: "AnnotationFormDialog",
      component: () => import("../dialogs/AnnotationEditForm"),
      title: "Edit Annotation",
      cancelButton: true,
      submitButtonText: "Save",
      onSubmit: async ({ rootStore }) => {
        const handler = (rootStore as any).routerStore?.dialogSubmitHandler;
        if (handler) {
          const success = await handler();
          if (success) {
            (rootStore as any).routerStore?.closeDialog();
          }
          return success;
        }
        return false;
      },
    },
  ],
};

export default PdfEditorRoute;
